import { ChildrenModelBase } from './children-base.model';

export class DataType extends ChildrenModelBase {
    type: string;
    code: string;
    description: string;
}